import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Button } from '@eds-web/react';
import { useHistory } from 'react-router-dom';
import styled from '@emotion/styled';

import { StyledPrizeContainer } from './Prizes.style';
import { StepComponentProps } from './PrizeStep';
import { useSelector } from 'react-redux';
import { selectAccountIsUnder18 } from '../../selectors/account.selector';
import { PRIZE_V2_ROUTER } from '../../routes/routes';
import { device } from '../../constants/breakpoint';

const MobileButtonContainer = styled.div`
    display: none;
    @media screen and ${device.laptop} {
        margin-top: 24px;
        display: flex;
        justify-content: center;

        button {
            width: 100%;
        }
    }
`;

const ContentContainer = styled.div`
    display: flex;
    gap: 32px;
    flex-direction: column;
    padding-top: 32px;
`;

export const Step3: React.FC<StepComponentProps> = ({ isCash = false, offlinePayment = false }) => {
    const { t } = useTranslation();
    const isUnder18 = useSelector(selectAccountIsUnder18);
    const history = useHistory();

    const handleBack = useCallback(() => {
        history.replace({
            pathname: PRIZE_V2_ROUTER
        });
    }, [history]);

    const getTitle = () => {
        if (!isCash) {
            return t('epic.esport.step3.content.title.pg.v2');
        }
        if (offlinePayment) {
            return t('epic.esport.step3.content.title.offline.v2');
        }
        return t('epic.esport.step3.content.title.v2');
    };

    const renderContent = () => {
        if (!isCash) {
            return <Text variant="paragraphMD">{t('epic.esport.step3.content.pg.v2')}</Text>;
        }
        if (offlinePayment) {
            return <Text variant="paragraphMD">{t('epic.esport.step3.content.offline.v2')}</Text>;
        }
        if (isUnder18) {
            return (
                <>
                    <Text variant="paragraphMD">
                        {t('epic.esport.step3.content.cash.under18.content1')}
                    </Text>
                    <Text variant="paragraphMD">
                        {t('epic.esport.step3.content.cash.under18.content2')}
                    </Text>
                    <Text variant="uiMDBold">
                        {t('epic.esport.step3.content.cash.under18.title2')}
                    </Text>
                    <Text variant="paragraphMD">
                        {t('epic.esport.step3.content.cash.under18.content3')}
                        <ul>
                            <li>
                                <Text variant="paragraphMD">
                                    {t('epic.esport.step3.content.cash.under18.content3.list1')}
                                </Text>
                            </li>
                            <li>
                                <Text variant="paragraphMD">
                                    {t('epic.esport.step3.content.cash.under18.content3.list2')}
                                </Text>
                            </li>
                            <li>
                                <Text variant="paragraphMD">
                                    {t('epic.esport.step3.content.cash.under18.content3.list3')}
                                </Text>
                            </li>
                        </ul>
                    </Text>
                    <Text variant="uiMDBold">
                        {t('epic.esport.step3.content.cash.under18.title3')}
                    </Text>
                    <Text variant="paragraphMD">
                        {t('epic.esport.step3.content.cash.under18.content4')}
                    </Text>
                    <Text variant="paragraphMD">
                        {t('epic.esport.step3.content.cash.under18.content5')}
                    </Text>
                </>
            );
        }
        return (
            <>
                <Text variant="paragraphMD">
                    {t('epic.esport.step3.content.cash.adult.content1')}
                </Text>
                <Text variant="paragraphMD">
                    {t('epic.esport.step3.content.cash.adult.content2')}
                </Text>
                <Text variant="uiMDBold">{t('epic.esport.step3.content.cash.adult.title1')}</Text>
                <Text variant="paragraphMD">
                    {t('epic.esport.step3.content.cash.adult.content3')}
                    <ul>
                        <li>
                            <Text variant="paragraphMD">
                                {t('epic.esport.step3.content.cash.adult.content3.list1')}
                            </Text>
                        </li>
                        <li>
                            <Text variant="paragraphMD">
                                {t('epic.esport.step3.content.cash.adult.content3.list2')}
                            </Text>
                        </li>
                        <li>
                            <Text variant="paragraphMD">
                                {t('epic.esport.step3.content.cash.adult.content3.list3')}
                            </Text>
                        </li>
                    </ul>
                </Text>
            </>
        );
    };

    return (
        <>
            <StyledPrizeContainer>
                <ContentContainer>
                    <Text variant="headingMD">{getTitle()}</Text>
                    <article>{renderContent()}</article>
                </ContentContainer>
            </StyledPrizeContainer>
            <MobileButtonContainer>
                <Button onClick={handleBack} size="lg" variant="solid">
                    {t('epic.esport.actions.back')}
                </Button>
            </MobileButtonContainer>
        </>
    );
};
